export const CLP_CURRENCY_ID = 1
export const USD_CURRENCY_ID = 2

export const CURRENCY_ID_BY_CODE = {
  CLP: CLP_CURRENCY_ID,
  USD: USD_CURRENCY_ID
}

export const maskCardNumber = last4Digits => `****-${last4Digits || ''}`

export const maskCardLabel = card =>
  `TC ${card.bankName} ${maskCardNumber(card.last4Digits)}${card.currency ? ` (${card.currency})` : ''}`
